up.compiler('[polymorphic-select]', (element) => {

  let typeFieldId = element.id.replace('id', 'type')
  let typeField = element.closest('form').querySelector(`#${typeFieldId}`)
  let polymorphicType = typeField.value

  // simple form as no logic to choose selected options via type and id, so we manually set selected options here
  Array.from(element.options).forEach(function(option) {
    if (option.value == element.value && option.getAttribute('polymorphic_type') == polymorphicType) {
      element.options.item(option.index).selected = true
    } else {
      element.options.item(option.index).removeAttribute('selected')
    }
  })

  element.addEventListener('change', function() {
    let typeName = element.selectedOptions[0].getAttribute('polymorphic_type')

    typeField.value = typeName
  })

})
